module.exports = __WEBPACK_EXTERNAL_MODULE_12__;


//////////////////
// WEBPACK FOOTER
// external "rxjs/add/observable/fromPromise"
// module id = 12
// module chunks = 0